module.exports = __webpack_public_path__ + "static/media/progress.cd987a2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/progress.mp4
// module id = 07is
// module chunks = 0